<div class="dialog dialog-medium dialog-flex-direction-column">
    <h4 class="dialog-inner h4-blue">What is High Limit Disability Insurance?</h4>
    <div class="dialog-inner">High-earning professionals like doctors often earn more than they can protect with
        individual and group disability insurance. These policies have maximum benefits, which can leave high-earning
        professionals with a coverage gap. High-limit disability insurance provides additional monthly benefit coverage
        to help the high-earning professional reduce or eliminate coverage gaps. So, high-limit disability insurance
        supplements any other disability insurance the professional may already have.</div>

    <div class="dialog-inner-buttons">
        <button class="button-mgis" (click)="close()" class="chat-button chat-button-define" mat-flat-button>Done</button>
    </div>